import { CommApiInstance } from "Utils/CommApiInstance";

const refererApi = async (
) => {
    return await CommApiInstance.post(`athn/referer`,{
        apiBody:{
        },
    })
    .then((Resp) => Resp.data);
}
export default refererApi;

const refererGetApi = async (
) => {
    return await CommApiInstance.post(`athn/referer/get`,{
        apiBody:{
        },
    })
    .then((Resp) => Resp.data);
}
export {refererGetApi};